import axios from 'axios';

// Use the same domain for both frontend and backend
const API_URL = process.env.NODE_ENV === 'production' 
  ? '' 
  : process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 10000
});

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      withCredentials: config.withCredentials
    });
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('API Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export const authAPI = {
  getUser: () => api.get('/auth/user'),
  logout: () => api.post('/auth/logout'),
  loginUrl: `${API_URL}/auth/discord`,
  testSession: () => api.get('/auth/test-session')
};

export const calendarAPI = {
  getEvents: () => api.get('/api/calendar/events'),
  getAllAvailability: () => api.get('/api/calendar/all'),
  saveEvent: (date, isAvailable) => api.post('/api/calendar/events', { date, isAvailable }),
  deleteEvent: (date) => api.delete(`/api/calendar/events/${date}`)
};

export default api;